import useMonacoEditor from "../useMonacoEditor";
import React, {useEffect} from "react";


const EditorPanel = ({ height, defaultCode, onChangeCode }) => {
  const { editor, editorRef, editorReLayout, setEditorCode, getEditorCode } = useMonacoEditor();
  useEffect(() => {
    editor.current.onDidBlurEditorText(() => {
      onChangeCode && onChangeCode(getEditorCode());
    });
  }, [editor]);
  useEffect(() => {
    return () => {
      onChangeCode && onChangeCode(getEditorCode());
    }
  }, []);
  useEffect(() => {
    editorReLayout();
  }, [editorReLayout, height]);
  useEffect(() => {
    setEditorCode(defaultCode)
  }, [setEditorCode, defaultCode]);
  return (
    <div style={{ height }} ref={editorRef} />
  );
};

export default EditorPanel;
